export default __webpack_public_path__ + "static/subset-Inter-SemiBold-7ba5aeb2ebe8c27b686787b2bcb2fd2c.woff2";